import { render } from "./NewComment.vue?vue&type=template&id=5a5ef011"
import script from "./NewComment.vue?vue&type=script&lang=js"
export * from "./NewComment.vue?vue&type=script&lang=js"
script.render = render

export default script